module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"interviews":"Отклики","sms":"SMS","calls":"Звонки","from":"из","add":"Пополнить"}}')
  delete Component.options._Ctor
}
